/* eslint-disable import/no-cycle */
import * as API from './api';

const StateCityModel = { ...API };

export default StateCityModel;
